import { render, staticRenderFns } from "./ManageChoose.vue?vue&type=template&id=472a4485&scoped=true&"
import script from "./ManageChoose.vue?vue&type=script&lang=js&"
export * from "./ManageChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a4485",
  null
  
)

export default component.exports